// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".highcharts-sankey-series .highcharts-link{fill-opacity:.75}", ""]);
// Exports
module.exports = exports;
